/* global gtag */

const setCurrentLocation = (
	locationId = '',
	yextId = '',
	locationName = ''
) => {
	const cookieName = 'fsa_location';
	const expirationDate = new Date();
	expirationDate.setFullYear(expirationDate.getFullYear() + 10);
	const cookieValue = encodeURIComponent(
		JSON.stringify({
			locationId,
			yextId,
			locationName,
		})
	);

	document.cookie = `${cookieName}=${cookieValue}; expires=${expirationDate.toUTCString()}; path=/`;

	if ('function' === typeof gtag && yextId) {
		gtag('event', 'User Location Set', {
			event_category: 'Location Finder',
			event_label: `${locationName} (${yextId})`,
		});
	}

	window.dispatchEvent(
		new CustomEvent('propel-current-location-set', {
			detail: {
				locationId,
				yextId,
				locationName,
			},
		})
	);
};

export default setCurrentLocation;
